<template>
	<div :class="(hasError)?'error row':'row'" v-if="isVisible">
		<div v-if="label && !Array.isArray(label) && label.length>0" :class="aspect.leftColumnWrapperClass">
			<label v-if="required" class="fh-label fh-required">{{label}}</label>
			<label v-else class="fh-label">{{label}}</label>
			<div v-if="tooltipPosition=='left' && tooltip != null && tooltip != '' && tooltip != undefined" class="fh-tooltip">
				<i class="fa fa-info"></i>
			</div>
		</div>
		<div :class="(label!==null && !Array.isArray(label))?formElementColumns:'fh-separator-column'">
			<div :class="(label!==null && !Array.isArray(label))?aspect.formFieldWrapperClass:'fh-separator-container'">
			 	<div v-if="showIconsInInputs && ((forceStatusIcon && this.error && this.error.length > 0) || hasError) && type!='select' && type!='html-block' && type!='separator' && type!='files' && type!='file' && type!='multiple_course_datepicker'" :class="errorClasses" :style="{color: errorColor}" ><i class="fa fa-exclamation-triangle"></i></div>
			 	<div v-if="showIconsInInputs && forceStatusIcon && !(this.error && this.error.length > 0)">
					 <div v-if="type!='checkbox' && type!='contract' && type!='select' && type!='html-block' && type!='hidden' && type!='separator' && type!='radio' && type!='files' && type!='file' && type!='extra-component' && type!='select-multiple'  && type!='multiple_course_datepicker'" :class="errorClasses" :style="{color: errorColor}" ><i class="fa fa-check"></i></div>
				</div>
			  <input v-if="type=='text' || type=='number' || type=='email' || type=='password' || type=='hidden'" ref="formElement" :class="aspect.formFieldClass" :type="type" v-model="fieldValue" :placeholder="placeholder" :disabled="!editable" />
			  <select v-if="type=='select'" :class="aspect.formFieldClass" :type="type" v-model="fieldValue" :disabled="!editable" :name="name"  ref="formElement">
				  <option v-if='placeholder && placeholder.length > 0' :value="null" disabled v-html="placeholder"></option>
				  <option v-for="(option, key) in options" :key="'name-'+key" :value="key" :disabled="!editable">{{selectVal(option)}}</option>
			  </select>
			  <form-element-select-multiple v-if="type=='select-multiple'" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder" :unique-name="uniqueName" :options="options"></form-element-select-multiple>
			  <div v-if="type=='radio'" ref="formElement">
				  <span v-for="(option, key) in options" :key="'name-'+key" class="form-element-radio">
					  <input type="radio" :value="key" v-model="fieldValue" :disabled="!editable" :id="'input-'+key+uniqueName" /> <label :for="'input-'+key+uniqueName" v-html="option" style="cursor: pointer;"></label>
				  </span>
			  </div>
			  <div v-if="type=='checkbox' || type=='contract'" ref="formElement">
				  <element v-if="Object.keys(options).length > 1 || type=='contract'" class="form-element-checkbox">
					  <div v-for="(option, key) in options" :key="'name-'+key">
						  <input type="checkbox" :value="key" v-model="multipleValue" :id="uniqueName+'-'+key" :checked="multipleValue.indexOf(key) >= 0"  :disabled="!editable"/> <label style="cursor:pointer;" :for="uniqueName+'-'+key" v-html="option"></label>
					  </div>
				  </element>
				  <element v-if="Object.keys(options).length == 1 && type!='contract'" class="form-element-checkbox">
					  <div v-for="(option, key) in options" :key="'name-'+key">
							<label :for="name">
								<input :id="name" type="checkbox" :value="key" v-model="fieldValue" :disabled="!editable" /> <span v-html="option"></span>
							</label>
					  </div>
				  </element>
			  </div>
			  <textarea v-if="type=='textarea'" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder" :class="aspect.formFieldClass"></textarea>
			  <form-element-multi-date-picker v-if="type=='multiple_datepicker'" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder"></form-element-multi-date-picker>
			  <form-element-course-multi-date v-if="type=='multiple_course_datepicker'" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder"></form-element-course-multi-date>
			  <form-element-datetime-picker v-if="type=='datetime-picker'" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder"></form-element-datetime-picker>
			  <form-element-strong-password v-if="type=='strong_password'" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder"></form-element-strong-password>
			  <form-element-date v-if="type=='date'" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable"></form-element-date>
			  <input v-if="type=='url'" ref="formElement" :class="aspect.formFieldClass" type="text" v-model="fieldValue" :placeholder="placeholder" :disabled="!editable" />
			  <form-element-phone v-if="type=='phone'" ref="formElement" :with-prefix="withPrefix" :phone-prefix="phonePrefix" :validations="validations" v-model="fieldValue" :placeholder="placeholder" :translations="translations" :aspect="aspect" :disabled="!editable"></form-element-phone>
			  <form-element-multiuploader  v-if="type=='file' || type=='files'" ref="formElement" :multiple="type=='files'" :validations="validations" v-model="fieldValue" :name="name" :translations="translations" :aspect="aspect" :oldValue="oldValue" :disabled="!editable"></form-element-multiuploader>
			  <form-element-location v-if="type=='location'" :refresh-index="refreshIndex" :label="label" ref="formElement" v-model="fieldValue" :translations="translations" :location="location" :aspect="aspect" :formElementColumns="formElementColumns" :required="required" :disabled="!editable" :with-address="withAddress" :cooperative="cooperative" :unique-name="uniqueName"></form-element-location>
			  <form-element-location-italy v-if="type=='location-italy'" :refresh-index="refreshIndex" :label="label" ref="formElement" v-model="fieldValue" :translations="translations" :location="location" :aspect="aspect" :formElementColumns="formElementColumns" :disabled="!editable"></form-element-location-italy>
			  <form-element-ckeditor v-if="type=='wysiwyg'" :minimal="false" :placeholder="placeholder" ref="formElement" :validations="validations" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :upload-url="uploadUrl"></form-element-ckeditor>
			  <form-element-upload-cropper v-if="type=='cropped-image'" ref="formElement" :validations="validations" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable"></form-element-upload-cropper>
			  <form-element-cf v-if="type=='cf'" :refresh-index="refreshIndex" :label="label" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :formFields="formFields" :disabled="!editable" :placeholder="placeholder"></form-element-cf>
			  <form-element-piva v-if="type=='vat'" :refresh-index="refreshIndex" :label="label" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder"></form-element-piva>
			  <form-element-partecipants v-if="type=='partecipants'" :label="label" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :placeholder="placeholder"></form-element-partecipants>
			  <form-element-repeater v-if="type=='repeater'" :label="label" ref="formElement" v-model="fieldValue" :translations="translations" :aspect="aspect" :disabled="!editable" :editable="editable" :placeholder="placeholder" :subfields="subfields" :name="name" :unique-name="uniqueName" :oldValue="oldValue"></form-element-repeater>
			  <div ref="formElement" class="row" v-if="type=='html-block'" v-html="value"></div>
			  <component ref="formElement" :is="value.component" class="row" v-if="type=='extra-component'" :formFields="formFields" :args.sync="value.args"></component>
			  <div ref="formElement" class="row" v-if="type=='separator'">
				  <div class="col-md-12">
					  <h3 class="fh-block-title fh-widget-title fh-title-small"><span>{{value}}</span></h3>
				  </div>
			  </div>
			  </div>
			  <div v-if="tooltip != null && tooltip != '' && tooltip != undefined" v-html="tooltip" class="fh-tooltip-body"></div>
			  <div v-if="cooperative && type!='html-block' && type!='separator' && type!='hidden'">
				<div v-if="cooperativeData" :id="'cooperative-'+uniqueName" :class="'collapse'+(cooperativeData.approved?'':' show')">
					<div>
						<div v-for="(message, index) in cooperativeData.messages" v-bind:key="uniqueName+'-'+index" v-html="message"></div>
						<textarea v-if="cooperativeData.approved==false" :placeholder="translations.cooperativeCommentPlaceholder" v-model="cooperativeData.comment" class="form-control cooperative" style="width: 100%; margin-top: 15px; margin-bottom: 15px; height: 85px;"></textarea>
						<div v-if="cooperativeData.admin" class="cooperative-buttons">
							<button @click="acceptField" v-if="cooperativeData.approved == false">Approva</button>
							<button @click="rejectField" v-if="cooperativeData.approved == true">Modifica nuovamente</button>
						</div>
					</div>
				</div>
			  </div>
		</div> 
		<div v-if="cooperative && type!='html-block' && type!='separator' && type!='hidden'" class="col-md-1 col-xs-2" :id="'cooperative-buttons-'+uniqueName">
			<i class="far fa-check-circle" :style='cooperativeData.approved?"color:green":"opacity:0.2"'></i>
			<i class="fa fa-info-circle" :style="cooperativeData.approved && (cooperativeData.messages.length == 0 || (cooperativeData.messages.length > 0 && cooperativeData.messages[0]==''))?'opacity:0.2;':'cursor: pointer;'" data-toggle="collapse" :data-target="'#cooperative-'+uniqueName" :aria-expanded="cooperativeData.approved?'false':'true'" aria-controls="'cooperative-'+uniqueName" @click="openCooperative()"></i>
		</div>
		<div v-if="hasError" :class="errorClasses!=null?errorClasses:'error-expl'" :style="{color: errorColor}" v-html="error"></div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: "form-element",
		props: {
			name: {type: String, required: true},
			uniqueName: {type: String, required: true},
			errorColor: {type: String, default: 'red'},
			type: {type: String, default: 'text'},
			label: null,
			value: null,
			oldValue: null,
			options:  {type: Object, default: function(){ return {}; }},
			placeholder: null,
			submitted: null,
			editable: {type: Boolean, default: true},
			tooltip: {type: String, default: ''},
			required: {type: Boolean, default: false},
			formFields: {type: Object, default: function(){ return {}; }},
			hidden: {type: Boolean, default: false },
			visibilityConditions: {type: Array, default: function(){ return []; }},
			validations: {type: Array, default: function(){ return []; }},
			translations: {type: Object, default: function(){ return {}; }},
			aspect: {type: Object, default: function(){ return {}; }},
			location: {type: Object, default: function(){ return {}; }},
			err: {type: Boolean, default: true},
			forceStatusIcon: {type: Boolean, default: false},
			response: null,
			refreshIndex: {type: Number, default: 0},
			tooltipPosition: { type:String, default: "bottom" },
			showIconsInInputs: { type:Boolean, default: true },
			subfields: { type: Object, function(){ return {}; } },
			uploadUrl: { type: String },
			withAddress: { type: Boolean, default: false },
			withPrefix: { type: Boolean, default: true },
			phonePrefix: { type: String, default: '0039' },
			cooperative: { type: Boolean, default: false },
			cooperativeData: {type: Object, default: function(){ return { admin: true, messages: [], approved: false, comment: null } }}
		},
		data() {
			return {
				error: null,
				fieldValue: this.value,
				multipleValue: [],
				errorClasses: this.aspect.errorClasses,
				loaded: false,
				serverValidationCount:0,
				fieldComment: null
			}
		},
		computed: {
			hasError(){
				if(this.loaded) this.validate()
				
				if(this.submitted && this.error && this.error.length > 0){
					return true
				}else{
					return false
				}
			},
			isVisible(){
				if(this.hidden){ return false; }
				if(!this.visibilityConditions || this.visibilityConditions.length == 0){
					this.$emit("update:visible", true);
					return true
				}else{
					var elementVisible = true
					for(var i=0; i<this.visibilityConditions.length; i++){
						var visibilityCondition = this.visibilityConditions[i]
						switch(visibilityCondition.operator){
							case "==":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value != visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
								break
							case "!=":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value == visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
								break
							case ">":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value > visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
								break
							case ">=":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value > visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
								break
							case "<":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value < visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
								break
							case "<=":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value <= visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
								break
							case "checked":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value != true){
									this.$emit("update:visible", false);
									return false
								}
								break;
							case "not-checked":
								if(this.formFields[visibilityCondition.operand]===undefined || this.formFields[visibilityCondition.operand].value == true){
									this.$emit("update:visible", false);
									return false
								}
								break;
							case "attribute_equal":
								if(this.formFields[visibilityCondition.operand].value == null || this.formFields[visibilityCondition.operand].value[visibilityCondition.attribute] != visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
							break;
							case "attribute_not_equal":
								if(this.formFields[visibilityCondition.operand].value != null && this.formFields[visibilityCondition.operand].value[visibilityCondition.attribute] == visibilityCondition.value){
									this.$emit("update:visible", false);
									return false
								}
							break;
							default:
								if(this.$refs.formElement !== undefined && typeof this.$refs.formElement.evaluateVisibityCondition === 'function' && (! this.$refs.formElement.evaluateVisibityCondition(visibilityCondition))){
									this.$emit("update:visible", false);
									return false
								}
						}
						
					}
					this.$emit("update:visible", true);
					return true;
				}
			},
			formElementColumns(){
				var isCooperative = this.cooperative && (this.type!='html-block' && this.type!='separator' && this.type!='hidden');
				/*
				if(isCooperative && this.type == "location"){
					return this.aspect.rightColumnWrapperClass;
				}*/
				return (this.label!==undefined && this.label!==null && this.label.length > 0)?(isCooperative?"col-md-8 col-xs-10":this.aspect.rightColumnWrapperClass):this.aspect.rightColumnWrapperFullWidthClass
			}
		},
		watch:{
			value: {
				deep: true,
				handler(){ this.fieldValue = this.value; }
			},
			fieldValue:{
				deep: true,
				handler(){
					this.$emit("input", this.fieldValue);
					this.$emit("change", this.uniqueName);
				}
			},
			multipleValue:{
				deep: true,
				handler(){
					this.fieldValue =  this.multipleValue;
				}
			},
			error: {
				deep: true,
				handler(){
					this.$emit('update:err', (this.error==null)?false:true);
				}
			}
		},
		mounted(){
			this.loaded = true
			switch(this.type){
				case "url":
					this.validations.unshift({type: "url"})
					break
				case "number":
					this.validations.unshift({type: "numeric"})
					break
				case "email":
					this.validations.unshift({type: "email"})
					break
				case "phone":
					this.validations.unshift({type: "phone"})
					break
				case "vat":
					this.validations.unshift({type: "vat"})
					break
				case "strong_password":
					this.validations.unshift({type: "strong-password"})
					break
				case "checkbox":
				case "radio":
					if(this.value != null && Array.isArray(this.value) && this.value.length > 0){
						this.multipleValue = this.value
					}
					break
			}
		},
		methods: {
			acceptField(event){
				event.preventDefault()
				this.cooperativeData.approved=true
				return false
			},
			rejectField(event){
				event.preventDefault()
				this.cooperativeData.approved=false
				return false
			},
			openCooperative(){
				this.cooperativeOpen = !this.cooperativeOpen;
			},
			async serverValidation(validationItem, serverValidationCount){
					console.log(serverValidationCount + " - " + this.serverValidationCount)
					if(serverValidationCount == this.serverValidationCount){
					if(validationItem.endpoint && validationItem.endpoint.length > 0){
						const params = new URLSearchParams();
						params.append(this.name, this.value);
						if(validationItem.fieldsToSend && validationItem.fieldsToSend.length > 0){
							for(var i=0; i<validationItem.fieldsToSend.length; i++){
								if(this.formFields[validationItem.fieldsToSend[i]].error != null && this.formFields[validationItem.fieldsToSend[i]].error != false){
									if(validationItem.callback!==undefined){
										validationItem.callback("error");
									}
									this.error = this.translations.depenencyError
									return
								}
								params.append(this.formFields[validationItem.fieldsToSend[i]].name, this.formFields[validationItem.fieldsToSend[i]].value);
							}
						}
						if(this.error = await axios.post(validationItem.endpoint, params).then((data) => {
							if(validationItem.expectedValue == null || validationItem.expectedValue == undefined){
								if(data.data != "valid"){ 
									if(validationItem.callback!==undefined){
										validationItem.callback("error");
									}
									return this.translations.validationServerError; 
								}else{
									if(validationItem.callback!==undefined){
										validationItem.callback(data.data);
									}
								}
							}else{
								if(validationItem.expectedValue == "number"){
									if(!isNaN(data.data)){
										if(validationItem.callback!==undefined){
											validationItem.callback(data.data);
										}
										this.$emit("update:response", data.data);
									}else{
										if(validationItem.callback!==undefined){
											validationItem.callback("error");
										}
										this.$emit("update:response", null);
										return this.translations.validationServerError; 
									}
								}else{
									if(validationItem.expectedValue == "object"){
										if(typeof data.data === 'object' && data.data !== null){
											if(validationItem.callback!==undefined){
												validationItem.callback(data.data);
											}											
											this.$emit("update:response", data.data);
										}else{
											if(validationItem.callback!==undefined){
												validationItem.callback("error");
											}
											this.$emit("update:response", null);
											return this.translations.validationServerError; 
										}
									}
								}
							}
						}).catch((e) => { 
							if(validationItem.callback!==undefined){
								validationItem.callback("error");
							}
							return this.translations.validationServerError; 
							
						})) return
					}
				}
			},
			selectVal(option){
				return (option.select_option_value)?option.select_option_value:option;
			},
			async validate(){
				if(this.required && ((this.fieldValue == null || this.fieldValue.length == 0 ) || (this.type=="files" &&  Array.isArray(this.fieldValue) && this.fieldValue.length > 0 && (this.fieldValue[0].name == null || this.fieldValue[0].name.length == 0)) )){
					this.error = this.translations.requiredWarning;
					return
				}else if((this.required || (this.fieldValue && this.fieldValue.length > 0) ) && this.validations && this.validations.length > 0){
					for(var i=0; i<this.validations.length; i++){
						var validationItem = this.validations[i];
						switch(validationItem.type){
							case "alphabetical":
								if(! /^[a-zA-Z() ]+$/.test(this.value)){
									this.error = this.translations.alphabeticalWarning;
									return
								}
								break;
							case "numeric":
								if(isNaN(this.value)){
									this.error = this.translations.numericWarning;
									return
								}
								break;
							case "email":
								if(! /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.value)){
									this.error = this.translations.emailWarning;
									return
								}
								break;
							case "phone":
								if(! /^[\s()+-]*([0-9][\s()+-]*){6,20}$/.test(this.value)){
									this.error = this.translations.phoneWarning;
									return
								}
								break;
							case "url":
								if(! /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#\-]+)*\/?(\?[\-a-zA-Z0-9-_]+=[a-zA-Z0-9-%\-]+&?)?$/.test(this.value)){
									this.error = this.translations.websiteWarning;
									return
								}
								break;
							case "minlength":
								if(this.value.length < validationItem.value){
									this.error = this.translations.minLenghtWarningPrefix+validationItem.value+this.translations.minLenghtWarningSuffix;
									return
								}
								break;
							case "maxlength":
								if(this.value.length > validationItem.value){
									this.error = this.translations.maxLenghtWarningPrefix+validationItem.value+this.translations.maxLenghtWarningSuffix;
									return
								}
								break;
							case "min":
								if(this.value < validationItem.value){
									this.error = this.translations.minWarningPrefix+validationItem.value+this.translations.minWarningSuffix;
									return
								}
								break;
							case "max":
								if(this.value > validationItem.value){
									this.error = this.translations.maxWarningPrefix+validationItem.value+this.translations.maxWarningSuffix;
									return
								}
								break;
							case "equal_to_field":
								if(this.formFields[validationItem.field].value != this.value ) {
									this.error = this.translations.fieldsNotEquals
									return
								}
								break;
							case "bigger_than_field":
								if(this.value != undefined && parseFloat(this.formFields[validationItem.field].value) >= parseFloat(this.value) ){
									this.error = this.translations.fieldsNotBigger
									return
								}
								break;
							case "smaller_than_field":
								if(this.value != undefined && parseFloat(this.formFields[validationItem.field].value) <= parseFloat(this.value) ){
									this.error = this.translations.fieldsNotSmaller
									return
								}
								break;
							case "italian_datetime":
								if(this.value.length < 10 || !/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4} [0-2][0-9]:[0-5][0-9]$/.test(this.value) ){
									this.error = this.translations.fieldsNotEquals
									return
								}
								break;
							case "italian_date":
								if(this.value.length != 10 || !/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(this.value) ){
									this.error = this.translations.fieldsNotEquals
									return
								}
								break;
							case "server_validation":
								this.serverValidationCount += 1;
								setTimeout((time)=>{ this.serverValidation(validationItem, time); }, 500, this.serverValidationCount);
								break;
							default:
								if(
									this.$refs.formElement &&
									typeof this.$refs.formElement.evaluateValidationCondition === 'function' &&
									(this.error = await this.$refs.formElement.evaluateValidationCondition(validationItem))
								){
									return
								}
						}
					}
				}
				this.error = null
			}
		}
	}
</script>
